import ButtonChoseList from "components/Common/ButtonChoseList";
import EntitySelectDialog from "components/Common/EntitySelectDialog";
import {
  getParameterByName,
  removeParam,
  updateURLParameter,
} from "helpers/utils";
import React, { useCallback, useEffect, useState } from "react";
import { ApiEndpoint } from "store/@core/endpoint";
import { EntityType } from "store/@core/entityType";

const { Grid, TextField, Box } = require("@material-ui/core");

export function ActorIdFilter({ locationSearch, setLocationSearch }) {
  const handleChange = (prop) => (e) => {
    const value = e.target.value || "";
    const search = updateURLParameter(locationSearch, prop, value);
    setLocationSearch(search);
  };

  return (
    <Grid container spacing={2}>
      <Grid item>
        <TextField
          variant="standard"
          margin="normal"
          label={"From Actor ID"}
          value={getParameterByName("actorIdFrom", locationSearch) || ""}
          onChange={handleChange("actorIdFrom")}
          type={"number"}
          style={{
            input: {
              color: "#fff !Important",
              "&::placeholder": {
                opacity: 1,
              },
            },
            label: { color: "#8c8c8c" },
          }}
        />
      </Grid>
      <Grid item>
        <TextField
          variant="standard"
          margin="normal"
          label={"To Actor ID"}
          value={getParameterByName("actorIdTo", locationSearch) || ""}
          onChange={handleChange("actorIdTo")}
          type={"number"}
          style={{
            input: {
              color: "#fff !Important",
              "&::placeholder": {
                opacity: 1,
              },
            },
            label: { color: "#8c8c8c" },
          }}
        />
      </Grid>
    </Grid>
  );
}

export function DateRangeFilter({
  locationSearch,
  setLocationSearch,
  rangeProps,
  fromLabel,
  toLabel,
  fromFilterKey,
  toFilterKey,
}) {
  const handleChange = (prop) => (e) => {
    const value = e.target.value || "";
    const search = updateURLParameter(locationSearch, prop, value);
    setLocationSearch(search);
  };

  return (
    <Grid container spacing={8}>
      <Grid item xs={6}>
        <TextField
          variant="standard"
          margin="normal"
          label={fromLabel}
          value={getParameterByName(fromFilterKey, locationSearch) || ""}
          onChange={handleChange(fromFilterKey)}
          fullWidth
          style={{
            input: {
              color: "#fff !Important",
              "&::placeholder": {
                opacity: 1,
              },
            },
            label: { color: "#8c8c8c" },
          }}
          type="date"
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          variant="standard"
          fullWidth
          margin="normal"
          label={toLabel}
          value={getParameterByName(toFilterKey, locationSearch) || ""}
          onChange={handleChange(toFilterKey)}
          type="date"
          style={{
            input: {
              color: "#fff !Important",
              "&::placeholder": {
                opacity: 1,
              },
            },
            label: { color: "#8c8c8c" },
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
    </Grid>
  );
}

export function LastUpdatedDate({ locationSearch, setLocationSearch }) {
  const handleChange = useCallback(
    (value) => {
      const safeValue = value.target.value.toString();
      const searchDate = updateURLParameter(
        locationSearch,
        "lastUpdatedAt",
        safeValue
      );
      setLocationSearch(searchDate);
    },
    [locationSearch, setLocationSearch]
  );

  return (
    <TextField
      variant="standard"
      margin={"normal"}
      type="date"
      fullWidth
      sx={{ width: "100px" }}
      value={getParameterByName("lastUpdatedAt", locationSearch) || ""}
      onChange={handleChange}
      label={"Last Updated Date"}
      color={"primary"}
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
}

export function CvesFilter({ locationSearch, setLocationSearch }) {
  const hasMultipleCVEs = getParameterByName("hasMultipleCVEs") || "";
  const locNames = getParameterByName("cves", locationSearch);
  const formatted = locNames?.split(",");
  const [selected, setSelected] = useState(formatted ?? []);
  const [open, setOpen] = useState(false);

  const handleAccept = useCallback(
    (value) => {
      const safeValue = value?.toString() || "";
      let searchParams = removeParam(locationSearch, "hasMultipleCVEs");
      searchParams = updateURLParameter(searchParams, "cves", safeValue);
      setSelected(value);
      setLocationSearch(searchParams);
    },
    [locationSearch, setLocationSearch]
  );

  //   useEffect(() => {
  //     if (hasMultipleCVEs) {
  //       const cves = savedCVEsParams.split("=")?.[1];
  //       setSelected(cves?.split(","));
  //     } else if (!hasMultipleCVEs) {
  //       setSelected([]);
  //     }
  //   }, [savedCVEsParamsAtom, hasMultipleCVEs]);

  return (
    <Box margin={0}>
      <ButtonChoseList
        title={"CVES"}
        selected={selected}
        onClick={() => setOpen(true)}
      />

      <EntitySelectDialog
        title={"CVEs"}
        open={open}
        handleClose={() => setOpen(false)}
        callback={handleAccept}
        entitySelections={selected}
        nameProp={"cve"}
        valueProp={"cve"}
        url={ApiEndpoint[EntityType.CveDefinition]}
      />
    </Box>
  );
}
